import React, { useState, useEffect } from "react";
import { FaSpinner } from "react-icons/fa";
import ReactDatePicker from "react-datepicker";
import { Table } from "react-bootstrap";
import moment from "moment";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import LeaveSummary from "./component/LeaveSummary";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { getDay } from "date-fns";
import LeaveHistory from "./component/LeaveHistory";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import * as Yup from "yup";
import FileUploader from "../../../components/FileUploader";
import DeleteModal from "../../../components/DeletePopUpComponent";

const EditSPLeave = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  let today = moment().format("DD-MMM-YYYY");

  const initialFormData = {
    FromDate: moment(new Date()).format("DD-MMM-YYYY"), // Initially empty (user must select)
    ToDate: moment(new Date()).format("DD-MMM-YYYY"), // Initially empty
    EmployeeID: "", // Empty string (or default value if needed)
    // dates: "", // Empty until dates are selected
    Purpose: "", // Empty string
    revisionNumber: "",
    leaveID: "", // Empty (or auto-generated later)
    rowstatus: 435, // Empty (or default like "0" if required)
    leavesFile: null, // No file selected initially
  };

  const [leaveDetails, setLeaveDetails] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [daysDifference, setDaysDifference] = useState(1);
  const [disabledDatess, setDisabledDatess] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [displayedDates, setDisplayedDates] = useState([
    moment().format("DD-MMM-YYYY"),
  ]);
  const [errors, setErrors] = useState({});
  const [leaveTypeoptions, setLeaveTypeOptions] = useState([]);
  console.log("leaveTypeoptions", leaveTypeoptions);

  const [leaveHistory, setLeaveHistory] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leaveSummaryOptions, setLeaveSummaryOptions] = useState([]);
  const [availableDates, setAvailableDates] = useState("");
  const [empGender, setEmpGender] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState([]);

  useEffect(() => {
    dispatch(
      updateNavbarHeading(
        `Edit ${empGender == 148 ? "PL/BL/SL" : empGender == 149 ? "ML/BL/SL" : "PL/BL/ML/SL"
        } Leave`
      )
    );
    fetchShowApi();
    setFormData(initialFormData);
  }, [id]);

  useEffect(() => {
    if (formData.FromDate && formData.ToDate) {
      const daysDiff = countWeekdays(
        moment(formData.FromDate, "DD-MMM-YYYY"),
        moment(formData.ToDate, "DD-MMM-YYYY")
      );
      setDaysDifference(daysDiff);
      setDisplayedDates(generateDateRange(formData.FromDate, formData.ToDate));
    }
  }, [formData]);

  useEffect(() => {
    if (formData?.LeaveTypeID) {
      const leaveSummary = leaveSummaryOptions?.find(
        (el) => el.LeaveID == formData?.LeaveTypeID
      );
      const leaveDetail = leaveDetails?.find(
        (el) => el.ID == formData?.LeaveTypeID
      );

      const accrued = Number(leaveSummary?.LeaveAccrued);
      const applied = Number(leaveSummary?.LeaveApplied);
      const approved = Number(leaveSummary?.LeaveApproved);
      const defaultDays = Number(leaveDetail?.DefaultDay);

      // Calculate balance
      const balanceDates =
        !isNaN(accrued) && !isNaN(approved) ? accrued - approved : defaultDays;
      console.log("balanceDates", balanceDates);

      // Check if leave balance is zero or applied equals default
      const isAppliedEqualToDefault =
        !isNaN(defaultDays) && !isNaN(applied) && defaultDays === applied;

      if (balanceDates === 0 || isAppliedEqualToDefault) {
        // toast.error("Zero Balance");
        return;
      }
      setAvailableDates(balanceDates);
    }
  }, [formData?.LeaveTypeID]);

  const fetchShowApi = async () => {
    setPageLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}get-special-leaves-details/${id}`
      );
      if (response?.status === 200) {
        const leaveType = response?.data?.leavetype;
        const leaveSummary = response?.data?.leaveSummary;
        const leavehis = response?.data?.leaveHistory;
        const leaveHeaderData = response?.data?.leaveList;

        const emp_Gender = response?.data?.employeegender?.Gender_020;
        dispatch(
          updateNavbarHeading(
            `Edit ${emp_Gender == 148 ? "PL/BL/SL" : "ML/BL/SL"} Leave`
          )
        );

        setEmpGender(emp_Gender);

        const FormEditData = {
          FromDate: moment(leaveHeaderData?.FromDate).format("DD-MMM-YYYY"),
          ToDate: moment(leaveHeaderData?.ToDate).format("DD-MMM-YYYY"),
          ID: leaveHeaderData?.ID,
          Purpose: leaveHeaderData?.Purpose, // Empty string
          revisionNumber: "",
          leavesFile: leaveHeaderData?.FileName,
          FilePath: leaveHeaderData?.FilePath,
          LeaveTypeID: response?.data?.leaveLine[0]?.LeaveID, // Empty (or auto-generated later)
          rowstatus: 435, // Empty (or default like "0" if required)
          // leavesFile: leaveHeaderData?.FilePath, // No file selected initially
        };
        setFileName(leaveHeaderData?.FileName);
        setLeaveHistory(leavehis);
        setFormData(FormEditData);
        setLeaveSummaryOptions(leaveSummary);
        setLeaveDetails(leaveType);


        const leaveopt = leaveType.map((el) => ({
          value: el.ID,
          label: el.Description,
          code: el?.Name,
         Note:
                    el?.ID == 6
                    ? `An employee shall be granted a maximum of two (2) paid calendar days of leave to attend to personal misfortunes, such as the death of an immediate family member (limited to spouse, parents, parents-in-law, and children).`
                    : el?.ID == 5
                    ? `A male employee is eligible for 3 working days of paid paternity leave on the birth of his child(ren). This leave must be availed within 1 month of the child(ren)’s birth and taken consecutively.`
                    : el?.ID == 7
                    ? `An employee may be granted a sabbatical leave for personal or professional development purposes, such as pursuing higher education, research, or other approved long-term activities. The duration and approval of such leave shall be subject to company policy and management discretion.`
                    : null,
        }));
        setLeaveTypeOptions(leaveopt);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error Fetchung Show API ", error);
    }
  };

  const adjustWeekendToFriday = (momentObj) => {
    const day = momentObj.isoWeekday(); // 6 = Saturday, 7 = Sunday
    if (day === 6) {
      return momentObj.clone().subtract(1, "day"); // Saturday -> Friday
    }
    if (day === 7) {
      return momentObj.clone().subtract(2, "days"); // Sunday -> Friday
    }
    return momentObj.clone();
  };

  const getSabbaticalMinMaxDates = (fromDateStr) => {
    const fromMoment = moment(fromDateStr, "DD-MMM-YYYY");
    const minToDate = adjustWeekendToFriday(fromMoment.clone().add(29, "days"));
    const maxToDate = adjustWeekendToFriday(fromMoment.clone().add(89, "days"));
    return { minToDate, maxToDate };
  };

  const filteredLeaveDetails = leaveDetails.filter((item) =>
    ["ML", "BL", "PL", "Total"].includes(item.Name)
  );

  const countWeekdays = (startDate, endDate, leaveTypeId = formData.LeaveTypeID) => {
    // If leave type ID is 4 or 7, count all days including weekends and holidays
    if (leaveTypeId === 4 || leaveTypeId === 7) {
      return moment(endDate).diff(moment(startDate), "days") + 1;
    }

    let count = 0;
    let currentDate = moment(startDate);

    while (currentDate.isSameOrBefore(endDate, "day")) {
      if (isWeekday(currentDate.toDate(), leaveTypeId)) {
        count++;
      }
      currentDate.add(1, "days");
    }
    return count;
  };

   const handleDateChange = (date, field) => {
      const formattedDate = date ? moment(date).format("DD-MMM-YYYY") : "";
  
      if (field === "FromDate") {
          const newFormData = {
              ...formData,
              FromDate: formattedDate || '',
          };
  
          if (formData.LeaveTypeID === 4) {
              // ✅ Type 4: Auto-calculate ToDate based on DefaultDay, disable ToDate field
              const defaultDays = Number(
                  leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay
              ) || 1;
  
              let toDate = moment(formattedDate, "DD-MMM-YYYY");
              let addedDays = 0;
  
              while (addedDays < defaultDays - 1) {
                  toDate.add(1, "day");
                  if (isWeekday(toDate.toDate())) {
                      addedDays++;
                  }
              }
  
              newFormData.ToDate = toDate.format("DD-MMM-YYYY");
              newFormData.isToDateDisabled = true; // <-- custom flag to disable ToDate input
          }
  
          else if (formData.LeaveTypeID === 7) {
              // Sabbatical Leave: Minimum 30 days, Maximum 90 days duration (weekend adjusted to Friday)
              const { minToDate, maxToDate } = getSabbaticalMinMaxDates(formattedDate);
              const currentToDate = moment(formData.ToDate, "DD-MMM-YYYY");
              if (!currentToDate.isValid() || currentToDate.isBefore(minToDate, "day") || currentToDate.isAfter(maxToDate, "day")) {
                  newFormData.ToDate = minToDate.format("DD-MMM-YYYY");
              }
          }

          else if (formData.LeaveTypeID === 6 || formData.LeaveTypeID === 5) {
              // Type 5 & 6: Fixed day range
              const defaultDays = Number(
                  leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay - 1
              ) || 1;
  
              let toDate = moment(formattedDate, "DD-MMM-YYYY");
              let addedDays = 0;
  
              while (addedDays < defaultDays) {
                  toDate.add(1, "day");
                  if (isWeekday(toDate.toDate())) {
                      addedDays++;
                  }
              }
  
              newFormData.ToDate = toDate.format("DD-MMM-YYYY");
          }
  
          else {
              // Default: ToDate = FromDate
              newFormData.ToDate = formattedDate;
          }
  
          setFormData(newFormData);
          countWeekdays(newFormData.FromDate, newFormData.ToDate);
          updateDateDisplay(newFormData.FromDate, newFormData.ToDate);
      }
  
      else if (field === "ToDate") {
          // 🚫 Disable ToDate edits for LeaveTypeID 4
          if (formData.LeaveTypeID === 4) {
              toast.info("To Date is auto-set for this leave type!");
              return;
          }
  
          const fromDateMoment = moment(formData.FromDate, "DD-MMM-YYYY");
          const toDateMoment = moment(formattedDate, "DD-MMM-YYYY");

          if (formData.LeaveTypeID === 7) {
              const { minToDate, maxToDate } = getSabbaticalMinMaxDates(formData.FromDate);
              if (toDateMoment.isBefore(minToDate, "day")) {
                  toast.error(`For Sabbatical Leave, minimum end date is ${minToDate.format("DD-MMM-YYYY")}!`);
                  return;
              }
              if (toDateMoment.isAfter(maxToDate, "day")) {
                  toast.error(`For Sabbatical Leave, maximum end date is ${maxToDate.format("DD-MMM-YYYY")}!`);
                  return;
              }
          }
  
          if (formData.LeaveTypeID === 6 || formData.LeaveTypeID === 5) {
              const expectedToDate = moment(formData.FromDate, "DD-MMM-YYYY")
                  .add(Number(leaveDetails?.find(el => el.ID == formData?.LeaveTypeID)?.DefaultDay) - 1, 'days')
                  .format("DD-MMM-YYYY");
  
              if (formattedDate !== expectedToDate) {
                  toast.error(`For this leave type, To Date must be exactly ${expectedToDate}`);
                  return;
              }
          } else if (toDateMoment.isBefore(fromDateMoment, "day")) {
              toast.error("To Date cannot be before From Date!");
              return;
          }
  
          setFormData({ ...formData, [field]: formattedDate || '' });
          updateDateDisplay(formData.FromDate, formattedDate);
      }
  };
  
  // Helper function to avoid code duplication
  const updateDateDisplay = (fromDate, toDate, leaveTypeId = formData.LeaveTypeID) => {
    const fromMoment = moment(fromDate, "DD-MMM-YYYY");
    const toMoment = moment(toDate, "DD-MMM-YYYY");
    setDaysDifference(countWeekdays(fromMoment, toMoment, leaveTypeId));
    setDisplayedDates(generateDateRange(fromDate, toMoment, leaveTypeId));
  };

  const generateDateRange = (fromDate, toDate, leaveTypeId = formData.LeaveTypeID) => {
    // If leave type ID is 4 or 7, include all dates
    if (leaveTypeId === 4 || leaveTypeId === 7) {
      let currentDate = moment(fromDate, "DD-MMM-YYYY");
      const endDate = moment(toDate, "DD-MMM-YYYY");
      let dates = [];

      while (currentDate.isSameOrBefore(endDate, "day")) {
        dates.push(currentDate.format("DD-MMM-YYYY"));
        currentDate.add(1, "days");
      }
      return dates;
    }

    // Original logic for other leave types
    let currentDate = moment(fromDate, "DD-MMM-YYYY");
    const endDate = moment(toDate, "DD-MMM-YYYY");
    let dates = [];

    while (currentDate.isSameOrBefore(endDate, "day")) {
      if (isWeekday(currentDate.toDate(), leaveTypeId)) {
        dates.push(currentDate.format("DD-MMM-YYYY"));
      }
      currentDate.add(1, "days");
    }

    return dates;
  };

  const isWeekday = (date, leaveTypeId = formData.LeaveTypeID) => {
    // If leave type ID is 4 or 7, allow all dates (including holidays and weekends)
    if (leaveTypeId === 4 || leaveTypeId === 7) {
      return true;
    }

    const day = moment(date).isoWeekday(); // 6 = Saturday, 7 = Sunday

    const today = moment();
    const firstDayOfCurrentMonth = today.startOf("month");
    const lastDayOfPrevMonth = firstDayOfCurrentMonth
      .clone()
      .subtract(1, "day");
    const firstDayOfPrevMonth = lastDayOfPrevMonth.clone().startOf("month");

    // Check if the date is in the previous month
    const isPrevMonth = moment(date).isBetween(
      firstDayOfPrevMonth,
      lastDayOfPrevMonth,
      "day",
      "[]" // Inclusive
    );

    const isWeekend = day === 6 || day === 7;
    const isHoliday = disabledDatess.some((disabledDate) =>
      moment(disabledDate, "DD-MMM-YYYY").isSame(moment(date), "day")
    );

    return !isWeekend && !isHoliday && !isPrevMonth;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);
    validateField(name, updatedData);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const schema = Yup.object().shape({
    LeaveTypeID: Yup.number()
      .typeError("Leave Type is required")
      .required("Leave Type is required"),

    Purpose: Yup.string().required("Purpose is required"),

    leavesFile: Yup.mixed().when("LeaveTypeID", (LeaveTypeID, schema) => {
      if (LeaveTypeID == 6) {
        return schema.nullable(); // No file required
      }
      return schema.required("Attachment is required"); // File required for other LeaveTypeIDs
    }),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));
    }
  };

  const handleEdit = (id) => {
    navigate(`/special-leave/edit/${id}`, { state: { disabledDatess } });
  };

  const handleSelectChange = async (value, name) => {
    const today = moment();
    let fromDate = today.clone();
    let toDate = today.clone();

    const leaveSummary = leaveSummaryOptions?.find((el) => el.LeaveID == value);
    const leaveDetail = leaveDetails?.find((el) => el.ID == value);

    const accrued = Number(leaveSummary?.LeaveAccrued);
    const applied = Number(leaveSummary?.LeaveApplied);
    const approved = Number(leaveSummary?.LeaveApproved);
    const defaultDays = Number(leaveDetail?.DefaultDay);

    // Calculate balance
    const balanceDates =
      !isNaN(accrued) && !isNaN(approved) ? accrued - approved : defaultDays;
    console.log("balanceDates", balanceDates);

    // Check if leave balance is zero or applied equals default
    const isAppliedEqualToDefault =
      !isNaN(defaultDays) && !isNaN(applied) && defaultDays === applied;

    if (balanceDates === 0 || isAppliedEqualToDefault) {
      toast.error("Leave balance not available for the selected type.");

      setFormData((prev) => ({
        ...prev,
        LeaveTypeID: null,
        FromDate: "",
        ToDate: "",
      }));

      setDaysDifference(0);
      setDisplayedDates([]);
      return;
    }
        if (value === 5 || value === 6 || value === 4) {
      const validDaysNeeded = defaultDays - 1;
      let addedDays = 0;

      while (addedDays < validDaysNeeded) {
        toDate.add(1, "day");
        if (isWeekday(toDate.toDate())) {
          addedDays++;
        }
      }
    } else if (value === 7) {
      const { minToDate } = getSabbaticalMinMaxDates(fromDate.format("DD-MMM-YYYY"));
      toDate = minToDate;
    }

    const newFormData = {
      ...formData,
      LeaveTypeID: value,
      FromDate: fromDate.format("DD-MMM-YYYY"),
      ToDate: toDate.format("DD-MMM-YYYY"),
    };

    await validateField(name, newFormData);
    setFormData(newFormData);
    updateDateDisplay(fromDate, toDate, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmit(true);

    try {
      // Validate schema
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear previous errors

      if (formData.LeaveTypeID === 7) {
        const toMoment = moment(formData.ToDate, "DD-MMM-YYYY");
        const { minToDate, maxToDate } = getSabbaticalMinMaxDates(formData.FromDate);

        if (toMoment.isBefore(minToDate, "day")) {
          toast.error(`Sabbatical Leave requires a minimum end date of ${minToDate.format("DD-MMM-YYYY")}.`);
          setSubmit(false);
          return;
        }
        if (toMoment.isAfter(maxToDate, "day")) {
          toast.error(`Sabbatical Leave cannot exceed maximum end date of ${maxToDate.format("DD-MMM-YYYY")}.`);
          setSubmit(false);
          return;
        }
      }

      // Prepare leave lines
      const updatedLeaveApplicationLines = displayedDates.map((date, index) => {
        const leaveOption = leaveTypeoptions.find(
          (option) => option.value === formData?.LeaveTypeID
        );
        const leaveID = leaveOption ? leaveOption.value : null;

        return {
          LineNo: index + 1,
          Date: date,
          LeaveID: leaveID, // use the resolved ID
        };
      });

      // Update form data
      const updatedFormData = {
        ...formData,
        NoOfDays:daysDifference,
        leaveApplicationLines: updatedLeaveApplicationLines,
      };
      setFormData(updatedFormData);

      // Call API and capture response
      const response = await PostFormServiceCaller(
        `${API_URL}update-special-leaves-details/${id}`,
        updatedFormData,
        "put"
      );

      if (response?.status === 200) {
        toast.success("Leave submitted successfully!");
        fetchShowApi();

        // Reset form
        setFile(null);
        setFileName("");
        setFormData({
          Purpose: "",
          FromDate: today,
          ToDate: today,
          leaveApplicationLines: [],
          leavesFile: null,
        });
        setDisplayedDates([moment().format("DD-MMM-YYYY")]);

        // Navigate after short delay
        setTimeout(() => {
          navigate(`/apply/special-leave`);
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Failed to submit leave application";
      // toast.error(errorMessage);
    } finally {
      setSubmit(false); // only once
    }
  };


  const [fileUrl, setFileUrl] = useState(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const handleFile = (files) => {
    if (!files) return; // ✅ stop if null or undefined

    const selectedFile = files instanceof File ? files : files[0]; // works for File and FileList

    if (!selectedFile) {
      setFile(null);
      setFileName(null);
      setFileUrl(null);
      setFormData((prevState) => ({
        ...prevState,
        leavesFile: null,
      }));
      return;
    }

    // ✅ Allowed file types
    const allowedTypes = [
      "application/pdf",
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        leavesFile: "Only .doc, .docx, or .pdf files are allowed.",
      }));

      setFile(null);
      setFileName(null);
      setFileUrl(null);
      setFormData((prevState) => ({
        ...prevState,
        leavesFile: null,
      }));
      return;
    }

    // ✅ File size check (max 5 MB)
    if (selectedFile.size > 5 * 1024 * 1024) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        leavesFile: "Selected file exceeds 5MB.",
      }));

      setFile(null);
      setFileName(null);
      setFileUrl(null);
      setFormData((prevState) => ({
        ...prevState,
        leavesFile: null,
      }));
      return;
    }

    // ✅ Preview & state update
    const url = URL.createObjectURL(selectedFile);
    setFileUrl(url);

    setErrors((prevErrors) => ({
      ...prevErrors,
      leavesFile: "",
    }));

    setFile(selectedFile);
    setFileName(selectedFile.name);

    setFormData((prevState) => ({
      ...prevState,
      leavesFile: selectedFile,
    }));
  };
  const openDeleteModal = (item) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(item);
  };
  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      handleCancelLeave(selectedDeleteItem);
    }
  };
  const handleCancelLeave = async (data) => {
    // Convert dates to consistent format (DD-MMM-YYYY)
    const fromDateFormatted = moment(data.FromDate).format("DD-MMM-YYYY");
    const toDateFormatted = moment(data.ToDate).format("DD-MMM-YYYY");

    // Calculate working days difference
    const fromMoment = moment(data.FromDate);
    const toMoment = moment(data.ToDate);
    const daysDiff = countWeekdays(fromMoment, toMoment);

    // Generate date range
    const dateRange = generateDateRange(fromDateFormatted, toDateFormatted);

    // Update state
    setDaysDifference(daysDiff);
    setDisplayedDates(dateRange);

    // Create leave application lines
    const updatedLeaveApplicationLines = dateRange.map((date, index) => ({
      LineNo: index + 1,
      Date: date,
      LeaveID: data?.LeaveTypeID, // Using current formData's LeaveTypeID
    }));

    // Prepare updated form data
    const updatedFormData = {
      ...formData,
      leaveID: data?.LeaveTypeID,
      FromDate: fromDateFormatted,
      ToDate: toDateFormatted,
      leaveApplicationLines: updatedLeaveApplicationLines,
      applicationStatus: 1132,
      ID: data.ID,
    };

    try {
      let response;

      response = await PostFormServiceCaller(
        `${API_URL}special-leave-cancel/${data.ID}`,
        updatedFormData,
        "put"
      );
      if (response?.status == 200) {
        setShowDeleteModal(false);
        setSelectedDeleteItem(null);
        toast.success("Leave Cancelled Successfully");
        fetchShowApi();

        // setTimeout(() => {
        //     window.location.reload()
        // }, 2000)
      }
    } catch (error) {
      console.error("Special Leave Cancel Api Error", error);
    }
  };
  // Don't forget to revoke the object URL when component unmounts
  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  if (pageLoading) {
    return (
      <>
        <p className="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner className="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <div className="row gx-lg-1">
            <div className="col-12 col-lg-7 pe-1">
              <div className="container-fluid" id="skill-table-area">
                <form className="p-2" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-4">
                      <label htmlFor="leave-type" className="form-label">
                        Leave Type<span className="required">*</span>
                      </label>
                      <Select
                        name="LeaveTypeID"
                        className={` ${errors.LeaveTypeID ? "is-invalid" : ""}`}
                        isDisabled
                        value={
                          leaveTypeoptions?.find(
                            (el) => el.value == formData?.LeaveTypeID
                          ) || null
                        }
                        options={leaveTypeoptions}
                        onChange={(selectedOptions) =>
                          handleSelectChange(selectedOptions.value)
                        }
                      />
                      {errors.LeaveTypeID && (
                        <div className="invalid-feedback">
                          {errors.LeaveTypeID}
                        </div>
                      )}
                    </div>

                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-12">
                      <label htmlFor="leave-type" className="form-label">
                        Details<span className="required">*</span>
                      </label>
                      <textarea
                        type="text"
                        className={`form-control ${errors.Purpose ? "is-invalid" : ""
                          }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        value={formData.Purpose}
                        onChange={handleInputChange}
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-sm-4">
                      <label htmlFor="TargetDate" className="form-label">
                        From Date<span className="required">*</span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        changeYear
                        changeMonth
                        showPopperArrow
                          menuPortalTarget={document.body}
                                                 menuPlacement="auto"
                                                  // ✅ Correct way to set zIndex of the calendar
  styles={{
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // put it on top
    }),
  }}
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="FromDate"
                        id="FromDate"
                        filterDate={isWeekday}
                        onChange={(date) => handleDateChange(date, "FromDate")}
                        selected={
                          formData.FromDate
                            ? moment(formData.FromDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        minDate={moment()
                          .subtract(1, "month")
                          .startOf("month")
                          .toDate()}
                        maxDate={moment()
                          .add(4, "months")
                          .endOf("month")
                          .toDate()}
                      />
                    </div>
                    <div className="col-sm-4">
                      <label htmlFor="TargetDate" className="form-label">
                        To Date<span className="required">*</span>
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        disabled={[5, 6,4].includes(formData?.LeaveTypeID)}
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="ToDate"
                          menuPortalTarget={document.body}
                                                 menuPlacement="auto"
                                                  // ✅ Correct way to set zIndex of the calendar
  styles={{
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // put it on top
    }),
  }}
                        id="ToDate"
                        filterDate={isWeekday}
                        onChange={(date) => handleDateChange(date, "ToDate")}
                        selected={
                          formData.ToDate
                            ? moment(formData.ToDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        minDate={
                          formData.FromDate
                            ? (formData.LeaveTypeID === 7
                              ? getSabbaticalMinMaxDates(formData.FromDate).minToDate.toDate()
                              : moment(formData.FromDate, "DD-MMM-YYYY").toDate())
                            : moment()
                              .subtract(1, "month")
                              .startOf("month")
                              .toDate()
                        }
                        maxDate={
                          formData.FromDate
                            ? (formData.LeaveTypeID === 7
                              ? getSabbaticalMinMaxDates(formData.FromDate).maxToDate.toDate()
                              : (availableDates
                                ? moment(formData.FromDate, "DD-MMM-YYYY").add(availableDates - 1, "days").toDate()
                                : moment().add(4, "months").endOf("month").toDate()))
                            : moment().add(4, "months").endOf("month").toDate()
                        }
                      />
                    </div>
                    <div className="col-sm-12 col-md-3">
                      <div className="mb-3">
                        <label for="days" className="form-label">
                          No. of Days
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          value={daysDifference}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12">
                          <FileUploader
                            isRequired={
                              formData?.LeaveTypeID != 6 ? true : false
                            }
                            buttonLabel={"Upload"}
                            handleFile={handleFile}
                            accept=".pdf,.jpg,.jpeg,.png"   // ✅ now works
                            fileTypes={[
                              "application/pdf",
                              "image/jpeg",
                              "image/jpg",
                              "image/png",
                            ]} />
                          <small className="text-muted fst-italic ms-3 mt-1">
                            Only .pdf, .doc, or .docx files are allowed (max
                            5MB).
                          </small>
                          {errors.leavesFile && (
                            <div className="invalid-feedback d-block">{errors.leavesFile}</div>
                          )}
                        </div>
                      </div>
                      {fileName && (
                        <div className="mt-2">
                          File:{" "}
                          <a
                            href={formData?.FilePath || fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {fileName}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                  {formData?.LeaveTypeID !== 4 && formData?.LeaveTypeID !== null && <div className="row mt-1" >
                    <div className="col-sm-12">
                      <h6>Note :</h6>
                      <p
                        style={{ paddingLeft: "40px" }}
                        className="fst-italic text-danger text-opacity-50"
                      >
                        {leaveTypeoptions?.find(ele => ele?.value === formData?.LeaveTypeID)?.Note || null}
                      </p>

                    </div>

                  </div>}
                  <div className="text-end">
                    <button
                      type="button"
                      className="cancel-btn me-2"
                      onClick={() => navigate(`/apply/special-leave`)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      {submitted ? (
                        <FaSpinner className="sm-spinner" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-12 col-lg-5 pe-1">
              <LeaveSummary leaveDetails={leaveSummaryOptions} />
              <LeaveHistory
                leaveHistory={leaveHistory}
                onEdit={handleEdit}
                onCancel={openDeleteModal}
                showAction={true}
                title="Leave History (ML/BL/PL/SL)"
              />
            </div>
          </div>
        </div>
        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          modalTitle="Cancel Leave Request"
          message="Are You Sure You Want to Cancel Leave?"
          submitBtnLabel="Yes, Cancel Leave"
          cancelBtnLabel="Close"
        />
      </>
    );
  }
};

export default EditSPLeave;
